module.exports = __webpack_public_path__ + "img/img1.c83cb076.png";